/**
* @name: frameSubMenu
* @author: weiyong
* @date: 2022-10-02 22:19
* @description：frameSubMenu
* @update: 2022-10-02 22:19
*/
<template>
  <div :class="[prefixCls,getMenuFlag?'expand':'min']">
    <div class="menu-body" :style="menuSty">
      <Menu
        v-model:openKeys="openKeys"
        v-model:selectedKeys="selectedKeys"
        :style="getMenuFlag?'width: 218px':'width: 62px'"
        mode="inline"
        @click="menuClick"
      >
        <template :key="oneMenuItem.id" v-for="oneMenuItem in itemMenu.children">
          <app-menu-item :oneMenuItem="oneMenuItem"/>
        </template>
      </Menu>
    </div>
    
    <div @click="openCloseMenu" style="font-size: 12px;color: #999"  class="divider-btn">
      <left-outlined v-if="getMenuFlag" />
      <right-outlined v-if="!getMenuFlag" />
    </div>
  </div>

</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "frameSubMenu",
});
</script>

<script lang="ts" setup>
import Icon from '@/components/Icon/index';
import {BellOutlined} from '@ant-design/icons-vue';
import { Menu,SubMenu,MenuItem } from 'ant-design-vue';
import AppMenuItem from "@/layouts/layoutFrame/appFrame/appFrameCom/app-menu-item.vue";
import {ref, toRefs, unref, watch} from 'vue';
import {useDesign} from "@/hooks/web/useDesign";
import {useRouter} from "vue-router";
import {LeftOutlined,RightOutlined} from '@ant-design/icons-vue';
import {useMenuHooks} from "@/layouts/layoutFrame/hooks/useMenuHooks";
import {useSubAppInfos} from '@/hooks/layouts/useSubAppInfos';
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";
import {PageEnum} from "@/enums/pageEnum";


const {prefixCls} = useDesign('frameSubMenu');
const {t} = useI18n()
const {getMenuFlag,openCloseMenu} = useSubAppInfos();
const {
  getMenuTheme
} = useMenuSetting();

const selectedKeys = ref<string[]>([]);
const openKeys = ref<string[]>([]);

const router = useRouter();
const openPage = function () {
  router.push({path: '/xm-operate-account/system/service'})
}

const props = defineProps({
  itemMenu:{
    type:Object
  }
})
const {itemMenu}:any = toRefs(props);

/**
 * 将菜单展开
 */
const initOpenKeys=function (){
  if(unref(itemMenu).children&&unref(itemMenu).children.length>0){
    unref(itemMenu).children.forEach((itemId)=>{
      openKeys.value.push(itemId.id);
    })
  }
}

onMounted(()=>{
  initOpenKeys();
})

watch(itemMenu,(newVal)=>{
  initOpenKeys();
})

const menuSty=computed(()=>{
  const sty={};
  sty["height"]="100%";
  return sty;
})


const {menuClick} = useMenuHooks(router,t);
const { currentRoute } = useRouter();
watch(
  [() => currentRoute.value.path],
  () => {
    const route = unref(currentRoute);
    //如果是打开首页
    if(PageEnum.BASE_HOME_URL===currentRoute.value.path||"/dashboard/appMainPage"===currentRoute.value.path){
      selectedKeys.value=[];
    }else{

    }
  }
);
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-frameSubMenu';
@sub-header-app: 50px;

@menu-body: 220px;
@menu-min-body: 66px;


.@{prefix-cls} {
  width: @menu-body;
  border-right: 1px solid #dfdfdf;
  height: calc(100% - @sub-header-app);
  background-color: #FFF;
  position: absolute;
  overflow: hidden;

  .menu-body{
    height: 100%;
    overflow-x:hidden;
    overflow-y:auto;
  }
  .ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left{
    border-right: 0px solid #f0f0f0;
  }

  &.expand{
    width: @menu-body;
  }
  &.min{
    width: @menu-min-body;

    .ant-menu-submenu-expand-icon, .ant-menu-submenu-arrow{
      right: 6px;
    }

    .ant-menu-item.ant-menu-item-only-child{
      padding-left: 26px !important;
    }
  }

  svg{
    font-size: 18px;
  }
}

.divider-btn{
  top: 42px;
  position: absolute;
  width: 12px;
  right:0;
  height: 24px;
  line-height: 24px;
  border-radius: 12px 0 0 12px;
  cursor: pointer;
  transition-duration: .2s;
  text-align: center;
  background: #e3f1ff;
  color: #0d7df2;
}

.divider-btn span{
  font-size: 13px;
  position: relative;
  left: 2px;
  transform: scale(.8);
}


</style>
